import { render } from "./ManifestDashboard.vue?vue&type=template&id=8bddb834&scoped=true"
import script from "./ManifestDashboard.vue?vue&type=script&lang=js"
export * from "./ManifestDashboard.vue?vue&type=script&lang=js"

import "./ManifestDashboard.vue?vue&type=style&index=0&id=8bddb834&scoped=true&lang=css"

import exportComponent from "/codebuild/output/src2981498683/src/lrex-site/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-8bddb834"]])

export default __exports__